import React from 'react';
import { graphql, Link } from 'gatsby';
import { get as _get } from 'lodash-es';
import Helmet from 'react-helmet';
import Layout from '../components/Layout';
import BlogRoll from '../components/Blog/BlogRoll';
import AuthorHeader from '../components/Author/AuthorHeader';
import useAuthorPlaceholderImage from '../graphql/staticQueries/useAuthorPlaceholderImage';

import PartialHeader from '../components/Partials/PartialsHeader';
import PartialQuestion from '../components/Partials/PartialsQuestion';

export const AuthorTemplate = ({ author, pageUrl }) => {
  const defaultImg = useAuthorPlaceholderImage().fixed;
  const authorImage =
    _get(author, 'frontmatter.profileImageFixed.childImageSharp.fixed') ||
    defaultImg;

  const sortedPosts = author.frontmatter.relatedPostsWrittenByAuthor;
  sortedPosts.sort((a, b) => {
    return new Date(b.frontmatter.date) - new Date(a.frontmatter.date);
  });
  return (
    <Layout
      title={`Our authors - ${author.frontmatter.fullName} | Ulam Labs`}
      seoImage={_get(authorImage, 'src', '')}
      description="We share insights regarding software development for business. Meet the author."
      darkHeader
    >
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <PartialHeader>
        <AuthorHeader
          author={author}
          authorImage={authorImage}
          pageUrl={pageUrl}
        />
      </PartialHeader>
      {author.frontmatter.relatedPostsWrittenByAuthor.length ? (
        <div className="knowledge text-format main-view">
          <div className="container">
            <div className="content author">
              <BlogRoll posts={sortedPosts} showAds={false} firstBig={false} />
            </div>
          </div>
        </div>
      ) : (
        <div className="container">
          <div className="error-view" style={{ height: '50vh' }}>
            <div className="body">
              <div className="sbt">We&apos;re sorry</div>
              <div className="msbt">
                This author does not have any posts... yet
              </div>
              <Link to="/blog/" className="btn btn-main">
                Go back to blog
              </Link>
            </div>
          </div>
        </div>
      )}
      <PartialQuestion />
    </Layout>
  );
};

export default function Author(props) {
  const author = _get(props, 'data.authorData', {});
  const { location } = props;
  return <AuthorTemplate pageUrl={location} author={author} />;
}

export const authorPageQuery = graphql`
  query AuthorPageQuery($id: String!) {
    authorData: markdownRemark(id: { eq: $id }) {
      ...authorData
    }
  }
`;
